// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_verificationTab__1dDzL {\n  height: 120px;\n  border: 1px solid rgba(231, 241, 199, 0.35);\n  border-radius: 0 0 6px 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.common_verificationTab__1dDzL > div {\n  margin-top: 0;\n  width: 90%;\n}", ""]);
// Exports
exports.locals = {
	"verificationTab": "common_verificationTab__1dDzL"
};
module.exports = exports;
